// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldClickable, FormFieldIcon } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { xBaseTheme } from "@tps/XDL/types";
import { color, ellipsis } from "@tps/XDL/Utilities";
import { css } from "styled-components";

const PlaceholderSelector = `
        &::placeholder,
        &::-webkit-input-placeholder
`;

export const placeholderStyle = css`
    ${PlaceholderSelector} {
        font-size: 14px;
        letter-spacing: 0;
        line-height: 16px;
        font-style: italic;
        max-width: 100%;
        color: ${color("common.ui4")};
    }
`;

export default {
    defaultProps: {
        border: "rectangle",
        sizeVariant: "default",
        mergeCss: true,
        labelProps: {
            mergeCss: true,
            size: 12,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 17px;
                min-height: initial;
            `,
        },
        errorProps: {
            mergeCss: true,
            size: 14,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        hintProps: {
            mergeCss: true,
            size: 14,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        backgroundColor: "common.ui1",
        cssOverrides: {
            formInputWrapper: css`
                input:not(.react-datetime-picker__inputGroup__input),
                textarea,
                select:not(.react-datetime-picker__inputGroup__input) {
                    transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                    &:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                        box-shadow: inset 0 1px 0 0 ${color("common.ui7", 0.1)};

                        ${placeholderStyle}

                        &:not([class^="PopoverTriggerInput"]):hover:not(:disabled) {
                            border: 1px solid ${color("common.ui8")};
                        }

                        &:not([class^="PopoverTriggerInput"]):focus:not(:disabled) {
                            border: 1px solid ${color("common.ui9")};
                        }
                    }
                    &:disabled::placeholder {
                        font-style: normal !important;
                        color: ${color("text.main")};
                    }
                }
                ${FormFieldClickable} {
                    ${IconWrapper} {
                        background: transparent;
                    }
                    &:hover {
                        ${IconWrapper}, svg {
                            color: ${color("common.ui8")};
                        }
                    }
                }
                input,
                select {
                    &:not(.react-datetime-picker__inputGroup__input) {
                        ${ellipsis(1)}
                        text-overflow: ellipsis;
                    }
                }
            `,
            inputSelect: css`
                box-shadow: inset 0 1px 0 0 ${color("common.ui7", 0.1)};
            `,
        },
    },
} as xBaseTheme["formField"];
